export enum FeatureFlags {
	CroatianOlympicCommittee = "CroatianOlympicCommittee",
	InvoicesModuleEnabled = "InvoicesModuleEnabled",
	DmsModuleEnabled = "DmsModuleEnabled",
	PublicAdministrationModuleEnabled = "PublicAdministrationModuleEnabled",
	EpkModuleEnabled = "EpkModuleEnabled",
	EDeliveryModuleEnabled = "EDeliveryModuleEnabled",
	KbcDocsAndQuality = "KbcDocsAndQuality",
	DigitalSignatureEnabled = "DigitalSignatureEnabled",
	ReportsModuleEnabled = "ReportsModuleEnabled"
}

export const FeatureFlagPermisssionGroups = {
	[FeatureFlags.CroatianOlympicCommittee]: "CroatianOlympicCommitteeDataManagement",
	[FeatureFlags.InvoicesModuleEnabled]: "InvoicesManagement",
	[FeatureFlags.DmsModuleEnabled]: "DMS"
};

export const getFeatures = (): Array<string> => {
	return Object.keys(FeatureFlags);
};

export const getFeaturePermissionGroupNames = (): Array<string> => {
	return Object.values(FeatureFlagPermisssionGroups);
};
